import { render, staticRenderFns } from "./LeadStatusAlert.vue?vue&type=template&id=5ffa7478"
import script from "./LeadStatusAlert.vue?vue&type=script&lang=ts"
export * from "./LeadStatusAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports